import { shouldNotForwardProps } from '../../helpers';
import { Link } from '../Link';
import { styled } from '../muiReexports';
import { Typography } from '../Typography';
const TypographyStyled = styled(Typography, shouldNotForwardProps('cursor', 'hoverColor', 'enableUserSelect', 'lineHeight', 'wrap'))(({ theme, cursor, hoverColor, lineHeight, enableUserSelect, wrap }) => ({
    fontSize: 'inherit',
    userSelect: 'none',
    ...(lineHeight && { lineHeight }),
    ...(enableUserSelect && { userSelect: 'auto' }),
    ...(!wrap && {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }),
    ':hover': {
        cursor: cursor ?? 'default',
        // TODO: workaround (textMedium not working, expected color hex)
        color: hoverColor === 'textMedium' ? theme.palette.text.medium : theme.palette.primary.dark,
    },
}));
export const LinkStyled = styled(Link, shouldNotForwardProps('enableUserSelect', 'wrap'))(({ enableUserSelect, wrap }) => ({
    userSelect: enableUserSelect ? 'auto' : 'none',
    ...(!wrap && {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }),
}));
export { TypographyStyled };
